var ___EXPOSE_LOADER_IMPORT___ = require("-!./marked.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../../../../srv/zulip-npm-cache/34c029af70b5991510af6d2a74087645b48f04cf/node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["marked"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["marked"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
